module.exports = __webpack_public_path__ + "static/media/urban.21c291f4.png";